<template>
  <div class="subexponent__table">
    <table class="subexponent__table-company">
      <tbody>
        <tr>
          <th style="width: 200px;">{{ $t("common.companyName") }}</th>
          <th style="width: 81px;">
            {{ $t("event.subexponent.modal.companyProfile") }}
          </th>
          <th style="width: 88px;">
            {{ $t("event.subexponent.modal.catalogApplication") }}
          </th>
          <th style="width: 122px;">
            {{ $t("event.subexponent.modal.participantPasses") }}
          </th>
          <th style="width: 100px;">
            {{ $t("event.subexponent.modal.carPasses") }}
          </th>
          <th style="width: 150px;">
            {{ $t("event.subexponent.modal.access") }}
          </th>
          <th></th>
        </tr>
      </tbody>

      <tr v-for="subexponent in subexponents" :key="subexponent.invite_id">
        <td>
          <a
            href="#"
            @click.prevent="$emit('go-to-subexponent', subexponent)"
            class="subexponent__table-company-title"
          >
            {{
              locale === "en"
                ? subexponent.company.name_eng
                : subexponent.company.name_rus
            }}
          </a>
        </td>
        <td>
          <DotText
            :class="{
              _warning: !hasCompleteCompany(subexponent),
              _success: hasCompleteCompany(subexponent)
            }"
          />
        </td>
        <td>
          <DotText
            :class="{
              _warning: !hasOrder(subexponent),
              _success: hasOrder(subexponent)
            }"
          />
        </td>
        <td>
          <div class="subexponent__table-company_qouta-box">
            <span class="subexponent__table-company_qouta-box-text">
              {{
                $t("event.passes.outOf", {
                  amount: subexponent.pass_personal,
                  total: subexponent.quota
                })
              }}
            </span>
            <tooltip
              custom-class="subexponent__table-company-drop__block"
              clickable
              position="bottom"
            >
              <icon class="svg-arrow" name="arrow-down_grey" />
              <template #content>
                <p class="text-description" style="margin-right: 20px">
                  {{ $t("event.subexponent.modal.availablePasses") }}
                  {{ availableQuotas }}
                </p>

                <InputNumber
                  :min="subexponent.pass_personal"
                  :max="availableQuotas + subexponent.quota"
                  v-model="subexponent.quota"
                  :disabled="isButtonDisabled"
                  @input="
                    updateSubexponentPersonalPassesQuota(subexponent, $event)
                  "
                />
              </template>
            </tooltip>
          </div>
        </td>
        <td>
          <span class="subexponent__table-company-value">
            {{ subexponent.pass_car }}
          </span>
        </td>
        <td>
          <Select
            :options="subExponentAccess"
            :disabled="!hasAccessToWrite"
            :value="subexponent.is_edit ? 'edit' : 'read'"
            @input="updateSubexponentAccessLevel(subexponent, $event)"
          />
        </td>
        <td>
          <Tooltip :label="$t('event.documents.deleteFile')">
            <LinkIcon
              v-if="hasAccessToWrite"
              class="subexponent__table-company-delete-button"
              icon="delete"
              grey
              @click="showDeletePopupSubexponent(subexponent)"
            >
            </LinkIcon>
          </Tooltip>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import hasCompleteCompany from "@/helpers/event";
import {
  LinkIcon,
  Tooltip,
  InputNumber,
  DotText,
  Select
} from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  components: {
    InputNumber,
    Tooltip,
    LinkIcon,
    DotText,
    Select
  },

  data() {
    return {
      locale: i18n.locale,
      subexponentIdToBeDeleted: null,
      openCardId: null
    };
  },

  computed: {
    ...mapGetters("event", ["hasAccessToWrite"]),
    subExponentAccess() {
      return ["edit", "read"].map(item => {
        return {
          value: item,
          title: this.$t(`event.subexponent.${item}`)
        };
      });
    }
  },

  props: ["available-quotas", "subexponents", "isButtonDisabled"],

  methods: {
    hasOrder(subexponent) {
      return (
        subexponent.catalog_order_id &&
        subexponent.catalog_order_status !== "draft"
      );
    },

    hasCompleteCompany(subexponent) {
      return hasCompleteCompany(subexponent.company);
    },

    updateSubexponentAccessLevel(subexponent, accessLevel) {
      this.$emit("update-access-level", {
        subexponent,
        accessLevel
      });
    },
    updateSubexponentPersonalPassesQuota(subexponent, participantPassQuota) {
      this.$emit("update-personal-passes-quota", {
        subexponent,
        participantPassQuota
      });
    },
    showDeletePopupSubexponent({ id }) {
      this.$emit("onDelete", id);
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";

.subexponent__table {
  margin: 16px 0 0 0;

  &-company {
    max-width: 780px;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    &_qouta {
      &-box {
        display: flex;
        color: #6d7179;
        font-size: 14px;
        font-weight: 500;
        &-text {
          margin-right: 10px;
          display: inline-block;
          opacity: 0.8;
        }
      }
    }
    &-drop__block {
      display: flex;
      justify-content: space-between;
      background-color: #f0f5f9 !important;
      border: transparent !important;
      align-items: center;
      left: -100px !important;
      &::before {
        display: none !important;
      }
    }
    &-title {
      @include h2();
      margin: 0 0 0 0;
      padding: 0 0 0 0;

      font-size: 16px;
      font-weight: normal;
      line-height: 1.5;

      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
    & .svg-icon.svg-arrow {
      width: 12px;
      height: 12px;

      &._rotated {
        transform: rotate(180deg);
      }
    }
    & .select__toggle {
      width: 100%;
      height: auto;
      border: transparent;
      padding: 0;
      &.select__toggle_disabled {
        background-color: transparent;
        & .svg-icon {
          color: #cdced0;
        }
      }
    }
    & .select__toggle-text {
      color: #6d7179;
      overflow: visible;
      width: auto;
      font-weight: 500;
      font-size: 14px;
    }
    & .select__toggle .svg-icon {
      color: #6d7179;
      width: 14px;
      height: 14px;
    }
    &-value {
      font-size: 13px;
      line-height: 1.54;
      color: #6d7179;
    }

    &-btn {
      display: flex;
      text-align: left;
      align-items: center;
      border: none;
      outline: none;
      font-size: 13px;
      line-height: 1.67;
      background-color: transparent;

      padding: 0 0 0 0;
      margin: 0 0 0 0;

      cursor: pointer;

      width: 100%;

      .svg-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        color: #a3a8b3;
        margin-left: auto;
      }
    }

    &-delete-button {
      margin-left: 16px;
      position: relative;
    }

    tr th {
      color: #a3a8b3;
      font-size: 12px;
      line-height: 1.33;
      font-weight: normal;
      border-top: 1px solid rgba(205, 206, 208, 0.5);
      border-bottom: 1px solid rgba(205, 206, 208, 0.5);
      padding: 15px 10px 16px 0;
      text-align: left;
      vertical-align: top;
    }

    tr td {
      border-top: 1px solid rgba(205, 206, 208, 0.5);
      border-bottom: 1px solid rgba(205, 206, 208, 0.5);
      padding: 15px 0 16px 0;
      text-align: left;
    }
  }
}
.value-drop__block-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f5f9;
}
</style>
